(() => {
  if (window.AsanovSizeChartLoaded) return;
  window.AsanovSizeChartLoaded = true;

  let activeModal = null;
  let lastFocusedElement = null;

  const syncChart = (chart) => {
    if (!chart) return false;
    let scope = chart.parentElement;
    let picker = null;
    while (scope && !picker) {
      picker = Array.from(scope.querySelectorAll('variant-picker')).find(
        (element) => element.dataset.productId === chart.dataset.productId
      );
      scope = scope.parentElement;
    }
    const selected = picker
      ? Array.from(picker.querySelectorAll('input:checked, select option:checked'))
          .map((element) => element.value)
          .find((value) => value === 'Футболка' || value === 'Лонгслів')
      : null;
    const garment = selected || chart.dataset.defaultGarment || 'Футболка';
    chart.querySelectorAll('[data-size-chart-garment]').forEach((panel) => {
      panel.hidden = panel.dataset.sizeChartGarment !== garment;
    });
    const available = garment !== 'Лонгслів' || chart.dataset.longsleeveChartAvailable === 'true';
    const trigger = chart.querySelector('[data-size-chart-open]');
    if (trigger) trigger.hidden = !available;
    return available;
  };

  const syncAllCharts = () => document.querySelectorAll('[data-asanov-size-chart]').forEach(syncChart);
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) syncAllCharts();
  });
  document.addEventListener('shopify:section:load', syncAllCharts);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAllCharts);
  else syncAllCharts();

  const getFocusable = (container) => Array.from(
    container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter((element) => !element.hasAttribute('disabled') && element.offsetParent !== null);

  const openModal = (modal, trigger) => {
    if (!modal) return;
    activeModal = modal;
    lastFocusedElement = trigger;
    modal.hidden = false;
    document.body.classList.add('asanov-size-chart-open');
    requestAnimationFrame(() => {
      modal.querySelector('[data-size-chart-close]')?.focus();
    });
  };

  const closeModal = (modal = activeModal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('asanov-size-chart-open');
    activeModal = null;
    lastFocusedElement?.focus();
    lastFocusedElement = null;
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-chart-open]');
    if (openButton) {
      const chart = openButton.closest('[data-asanov-size-chart]');
      if (syncChart(chart)) openModal(chart.querySelector('[data-size-chart-modal]'), openButton);
      return;
    }

    const closeButton = event.target.closest('[data-size-chart-close]');
    if (closeButton) {
      closeModal(closeButton.closest('[data-size-chart-modal]'));
      return;
    }

    /* Close when the user taps any empty overlay area outside the image panel. */
    if (activeModal && event.target === activeModal) {
      closeModal(activeModal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusable(activeModal);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
